type HastNode = {
  children?: HastNode[]
  properties?: Record<string, unknown>
  tagName?: string
  type?: string
}

const SANDBOX_SCHEME = "sandbox:"

/** Normalize a literal sandbox URI scheme before rehype-sanitize checks protocols. */
export function normalizeSandboxLinkSchemes() {
  return (tree: HastNode) => {
    const visit = (node: HastNode) => {
      if (node.type === "element" && node.tagName === "a") {
        const properties = node.properties
        const href = properties?.href
        if (
          properties &&
          typeof href === "string" &&
          href.slice(0, SANDBOX_SCHEME.length).toLowerCase() === SANDBOX_SCHEME
        ) {
          properties.href = SANDBOX_SCHEME + href.slice(SANDBOX_SCHEME.length)
        }
      }
      node.children?.forEach(visit)
    }
    visit(tree)
  }
}
